<template>
    <div class="cms_szolgkeres_outer">
        <GrcDB ref="GRCDB"></GrcDB>

        <div class="cms_szolgkeres_felt_cont">
            <div class="cms_szolgkeres_felt_col1">
                <GrcText ref="txtNev"
                grc_labeltext="Cég neve:"
                grc_placeholder=""
                grc_labelmode="above" grc_labelwidth="200px" 
                style="margin-bottom:8px;"
                />

                <GrcText ref="txtCim"
                grc_labeltext="Cég címe:"
                grc_placeholder=""
                grc_labelmode="above" grc_labelwidth="200px" 
                style="margin-bottom:8px;"
                />

                <GrcText ref="txtTevekenyseg"
                grc_labeltext="Tevékenység (pl. bőr, fog):"
                grc_placeholder=""
                grc_labelmode="above" grc_labelwidth="200px" 
                style="margin-bottom:8px;"
                />
            </div>
            <div class="cms_szolgkeres_felt_col2">
                <table class="cms_szolgkeres_felt_chk_table" cellspacing="0" cellpadding="0">
                <tr>
                    <td style="width:45px;" valign="top"><GrcCheckboxMobile ref="chkPatika" /></td>
                    <td valign="top" style="text-align:left; font-family:'CmsDefault'; font-size:15px; line-height:20px; color:#000;">
                        Csak gyógyszertárak
                    </td>
                </tr>
                </table>
                <table class="cms_szolgkeres_felt_chk_table" cellspacing="0" cellpadding="0">
                <tr>
                    <td style="width:45px;" valign="top"><GrcCheckboxMobile ref="chkKartya" /></td>
                    <td valign="top" style="text-align:left; font-family:'CmsDefault'; font-size:15px; line-height:20px; color:#000;">
                        Csak kártyaelfogadó helyek
                    </td>
                </tr>
                </table>

                <div class="cms_szolgkeres_felt_btncont">
                    <span class="cms_linkbutton cms_linkbutton_2" style="vertical-align:top; cursor:pointer;"
                    @click="Kereses(0)"><i class="fas fa-search" style="margin-right:8px;"></i>Keresés</span>                    
                </div>

            </div>

        </div>

        <div ref="liststart" class="width:100%; box-sizing:border-box; font-size:1px; line-height:1px; opacity:0;">&nbsp;</div>

        <div style="width:100%; box-sizing:border-box; text-align:center; margin-bottom:20px;" v-show="(PrevButtonEnabled==1)||(NextButtonEnabled==1)">
            <div class="cms_szolgkeres_pagebutton" v-show="PrevButtonEnabled==1" @click="Kereses(-1)"><i class="fal fa-chevron-left" style="margin-right:8px;"></i>Előző oldal</div>
            <div class="cms_szolgkeres_pagebutton" v-show="NextButtonEnabled==1" @click="Kereses(1)">Következő oldal<i class="fal fa-chevron-right" style="margin-left:8px;"></i></div>
        </div>

        <div class="cms_szolgkeres_listcont">
            <div v-for="(item, index) in LIST" :key="index" class="cms_szolgkeres_item">
                <div class="cms_szolgkeres_item_nev">{{item.Nev}}</div>

                <div class="cms_szolgkeres_item_col1">
                    <table class="cms_szolgkeres_item_fieldtable" cellspacing="0" cellpadding="0" v-show="item.Cim!=''">
                        <tr>
                            <td style="width:40px; font-size:18px;" valign="top"><i class="far fa-map-marker-alt"></i></td>
                            <td>{{item.Cim}}</td>
                        </tr>
                    </table>
                    <table class="cms_szolgkeres_item_fieldtable" cellspacing="0" cellpadding="0" v-show="item.Tevekenyseg!=''">
                        <tr>
                            <td style="width:40px; font-size:18px;" valign="top"><i class="far fa-clipboard-medical"></i></td>
                            <td>{{item.Tevekenyseg}}</td>
                        </tr>
                    </table>
                    <table class="cms_szolgkeres_item_fieldtable" cellspacing="0" cellpadding="0" v-show="item.Telefon!=''">
                        <tr>
                            <td style="width:40px; font-size:18px;" valign="top"><i class="far fa-phone"></i></td>
                            <td>{{item.Telefon}}</td>
                        </tr>
                    </table>
                    <table class="cms_szolgkeres_item_fieldtable" cellspacing="0" cellpadding="0" v-show="item.EmailCim!=''">
                        <tr>
                            <td style="width:40px; font-size:18px;" valign="top"><i class="far fa-envelope"></i></td>
                            <td>{{item.EmailCim}}</td>
                        </tr>
                    </table>
                    <table class="cms_szolgkeres_item_fieldtable" cellspacing="0" cellpadding="0" v-show="item.Honlap!=''">
                        <tr>
                            <td style="width:40px; font-size:18px;" valign="top"><i class="far fa-globe"></i></td>
                            <td>{{item.Honlap}}</td>
                        </tr>
                    </table>
                </div>
                <div class="cms_szolgkeres_item_col2">
                    <div class="cms_szolgkeres_item_kartya" v-show="item.Kartya==1">Kártyaelfogadó hely</div>
                    <div class="cms_szolgkeres_item_kp" v-show="item.Kartya==0">Készpénzes fizetés</div>
                    

                    <a class="cms_szolgkeres_item_honlap" target="_blank" :href="item.Honlap" v-show="item.Honlap!=''"><i class="fal fa-globe"></i></a>
                    <a class="cms_szolgkeres_item_map" target="_blank" :href="'https://map.google.com/?q='+item.Cim" v-show="item.Cim!=''"><i class="fal fa-route"></i></a>

                </div>

            </div>
        </div>

        <div style="width:100%; box-sizing:border-box; text-align:center; margin-bottom:20px;" v-show="(PrevButtonEnabled==1)||(NextButtonEnabled==1)">
            <div class="cms_szolgkeres_pagebutton" v-show="PrevButtonEnabled==1" @click="Kereses(-1)"><i class="fal fa-chevron-left" style="margin-right:8px;"></i>Előző oldal</div>
            <div class="cms_szolgkeres_pagebutton" v-show="NextButtonEnabled==1" @click="Kereses(1)">Következő oldal<i class="fal fa-chevron-right" style="margin-left:8px;"></i></div>
        </div>

        <div class="cms_szolgkeres_norecord" v-show="(LIST.length==0)&&(IsFirstMount==0)">Nincs a feltételeknek megfelelő szolgáltató</div>

        <div class="cms_szolgkeres_norecord" v-show="IsFirstMount==1">
            Kérem adja meg a szűrési feltételeket, majd kattintson a keresés gombra!
            <br><br>
            A program elfogad töredék szavakat is, így pl. cím megadása esetén elég a város nevét, tevékenységre keresés esetén pedig egy kulcszót (pl. "fog") megadnia.
        </div>


    </div>
</template>

<script>

import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcText from '../GrcComponents/GrcText.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'

export default {
  name: 'frmszolgkeres',
  components: {
    GrcDB,
    GrcText,
    GrcCheckboxMobile,
  },

  data () {
        return {
            LIST:[],
            PageID:0,
            PrevButtonEnabled:0,
            NextButtonEnabled:0,
            IsFirstMount:1,
        }
  },
  model: {

  },  
  methods:{

    async Init()
    {
        //this.Kereses("");
    },

    async Kereses(pDirection)
    {

        this.$refs.GRCDB.ShowLoading(false);

        let pPageID = 0;
        
        if (pDirection != 0)
        {
            pPageID = this.PageID + pDirection;
            if (pPageID < 0) { let pPageID = 0; }
        }

        var QP = {
            sSessionID: "[APPSESSIONID]",
            sNev: this.$refs.txtNev.GetText().trim(),
            sCim: this.$refs.txtCim.GetText().trim(),
            sTevekenyseg: this.$refs.txtTevekenyseg.GetText().trim(),
            iPatika: this.$refs.chkPatika.GetValue(),
            iKartya: this.$refs.chkKartya.GetValue(),
            iPageID: pPageID
        };


        var Q;
        await this.$refs.GRCDB.GetData("frmSzolgKeres_GetData", QP).then(res => { Q = res; });

        this.$refs.GRCDB.HideLoading();

        if (Q.APPERR[0].ERR != "")
        {
            console.log(Q);
            return;
        }

        this.LIST = Q.LIST;
        this.PageID = Q.DATA[0].PageID;
        this.PrevButtonEnabled = Q.DATA[0].PrevButton;
        this.NextButtonEnabled = Q.DATA[0].NextButton;

        this.IsFirstMount = 0;

        window.scrollTo(0, this.$refs.liststart.offsetTop - 60);

        

    },

  },
  created()
  {
    
  },

 mounted()
 {
    this.Init();
 },


}


</script>


<style scoped>


</style>
